import { jsx } from "react/jsx-runtime";
import React from "react";
import { Button, Popover, Position } from "@blueprintjs/core";
import classnames from "classnames";
import popoverOverflowModifiers from "./utils/popoverOverflowModifiers";
function DropdownButton({
  disabled,
  menu,
  noRightIcon,
  popoverProps,
  className,
  ...rest
}) {
  return /* @__PURE__ */ jsx(
    Popover,
    {
      minimal: true,
      modifiers: popoverOverflowModifiers,
      disabled,
      autoFocus: false,
      content: menu,
      position: Position.BOTTOM_LEFT,
      ...popoverProps,
      children: /* @__PURE__ */ jsx(
        Button,
        {
          disabled,
          className: classnames(className, "dropdown-button"),
          rightIcon: noRightIcon ? void 0 : "caret-down",
          ...rest
        }
      )
    }
  );
}
export default DropdownButton;
